The identifier for the `AdvertisementProduct`.
